import { ORDERED_LIST } from '../constants';
import { OrderedListElement } from '../types';

/** Create an ordered list element */
export const createOrderedList = (children: OrderedListElement['children']): OrderedListElement => {
    return { type: ORDERED_LIST, children };
};
